import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { PublicUser } from '@jw/types';

interface AuthState {
  user: PublicUser | null;
  accessToken: string | null;
  isAuthenticated: boolean;

  setAuth: (user: PublicUser, accessToken: string) => void;
  updateUser: (user: Partial<PublicUser>) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      isAuthenticated: false,

      setAuth: (user, accessToken) =>
        set({ user, accessToken, isAuthenticated: true }),

      updateUser: updates =>
        set(state => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),

      logout: () =>
        set({ user: null, accessToken: null, isAuthenticated: false }),
    }),
    {
      name: 'jw-auth',
      // Only persist user info, not the access token (re-fetched via refresh)
      partialize: state => ({ user: state.user }),
    },
  ),
);
